module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_tooltip-7c3f677f090d540180dd93e60328d614.svg";